<div class="modal-header sticky-modal-header">
  <div class="row">
    <div class="col-8">
      <h5 class="modal-title">Share Repository Data - {{this.fileInfo.lotOrHipText}} {{this.fileInfo.lotNumber}} - {{this.fileInfo.sale.saleName}}</h5>
    </div>
    <div class="col-4 text-right">
      <button type="button" tabindex="-1" class="btn btn-danger" (click)="modal.dismiss('Cross click')">Cancel</button>
      <button type="button" class="btn btn-primary ml-6" [disabled]="isNotValidToShare()" (click)="onSubmit()">Send</button>
    </div>
  </div>

  <div class="row" [hidden]="!isNotValidToShare()">
    <div class="col-12 text-center" style="color:red">
      <h6>There is no file to Share</h6>
    </div>
  </div>
</div>
<div class="modal-body">

  <form [formGroup]="emailForm">
    <div class="form-group row mb-3">
      <div class="col-sm-12">
        <label>Recipient(s)</label>
        <email-input formControlName="recipientEmails" [isEmailInvalid]="isEmailInVaild()"></email-input>
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="col-sm-12">
        <label for="subject">Email Subject</label>

        <input formControlName="subject" class="form-control" id="subject" [ngClass]="{
                'form-required-border':
                   emailForm.get('subject').invalid &&
                  (emailForm.get('subject').dirty ||
                    emailForm.get('subject').touched)
              }" />
      </div>
    </div>
    <!-- Email Message Section -->
    <div class="form-group row mb-3">
      <div class="col-sm-12">
        <label for="emailMessage">Email Message</label>

        <textarea formControlName="emailMessage" class="form-control" id="emailMessage" style="height:150px" [ngClass]="{
                'form-required-border':
                   emailForm.get('emailMessage').invalid &&
                  (emailForm.get('emailMessage').dirty ||
                    emailForm.get('emailMessage').touched)
              }"></textarea>


      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <label for="subject">Expire Share In </label>

        <div style="display: flex; align-items: center;">
          <input formControlName="expiry" type="number" min="1" max="365" class="form-control" id="expiry" [ngClass]="{
              'form-required-border':
                emailForm.get('expiry').invalid &&
                (emailForm.get('expiry').dirty || emailForm.get('expiry').touched)
            }" />
          <span style="margin-left: 8px;">Days</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group row mb-12">
      <div class="col-sm-4">
        Choose What to Include
      </div>
    </div>

    <div class="form-group row mb-3">
      <div class="col-sm-10">
        <div class="mb-2">X-Ray Images</div>
        <div class="form-check">
          <mat-checkbox formControlName="isShareXrayImages">
            <mat-label>X-Ray Images ({{ fileInfo.xrayCount }})</mat-label>
          </mat-checkbox>
        </div>
      </div>
      <hr />
    </div>
    <!-- Scope Files Section -->
    <div class="form-group row mb-3" *ngIf="fileInfo.scopeFiles.length > 0">
      <div class="col-sm-10">
        <div class="mb-2">Media</div>
        <div *ngFor="let file of fileInfo.scopeFiles" class="form-check">
          <mat-checkbox checked="true" (change)="onScopeFileChange($event, file.studyFileId)">
            <mat-label>{{ file.originalFileName }}</mat-label>
          </mat-checkbox>
        </div>
      </div>
      <hr />
    </div>
    <!-- Report Files Section -->
    <div class="form-group row mb-3" *ngIf="fileInfo.reportFiles.length > 0">
      <div class="col-sm-10">
        <div class="mb-2">Documents</div>
        <div *ngFor="let file of fileInfo.reportFiles" class="form-check">
          <mat-checkbox checked="true" (change)="onReportFileChange($event, file.studyFileId)">
            <mat-label>{{ file.originalFileName }}</mat-label>
          </mat-checkbox>
        </div>
      </div>
      <hr />
    </div>
  </form>
</div>
